/**
 * The monkey is an extra. On page load he waits until the app has started and the browser
 * has been quiet for a moment, so loading and preparing his model never competes with the
 * app's own start. Without idle callbacks (older Safari) he waits a fixed time instead.
 */
export const startupQuietMs = 1000
export const startupLimitMs = 20000
export const startupFallbackMs = 4000
/** A gap this long between idle periods, or less idle time than this left, means work ran. */
const busyGapMs = 100
const busyIdleMs = 10

/** Resolves once the main thread has been lightly loaded for a second, or at the limit. */
export function afterAppStartup(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof requestIdleCallback !== "function") {
      setTimeout(resolve, startupFallbackMs)
      return
    }
    const started = performance.now()
    let quietSince = started
    let previous = started
    const check = (deadline: IdleDeadline) => {
      const now = performance.now()
      if (now - previous > busyGapMs || deadline.timeRemaining() < busyIdleMs) quietSince = now
      previous = now
      if (now - quietSince >= startupQuietMs || now - started >= startupLimitMs) resolve()
      else requestIdleCallback(check, { timeout: Math.max(1, started + startupLimitMs - now) })
    }
    requestIdleCallback(check, { timeout: startupLimitMs })
  })
}
